// Module
var code = "<input type=\"text\" class=\"_timePicker\" placeholder=\"Time\" data-test-id=\"timepicker\"/> ";
// Exports
export default code;